import {ApDynformsConfigFieldset}         from '../../../../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {ApDynformsConfigNumerictextbox}   from '../../../../../ap-dynforms/config/ap-dynforms-config-numerictextbox';
import {nameOf}                           from '../../../../../ap-core/utils/ap-name-of';
import {IPpPlanningWizardDetailsFormData} from '../../pp-planning-wizard.types';
import {ApDynformsValidator}              from '../../../../../ap-dynforms/ap-dynforms-validator';
import {Validators}                       from '@angular/forms';
import {ApDynformsConfigPlaceholder}      from '../../../../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {WorkTypes}                        from '../../../../../stores/base-data/worrktypes.store';
import {ApTranslationService}             from '../../../../../ap-utils/service/ap-translation.service';
import {AgriportConstantsService}         from '../../../../../services/common/agriport-constants.service';
import {Injectable}                       from '@angular/core';

@Injectable()
export class DetailsUniformUiProvider {
  constructor(private translationService: ApTranslationService,
              private agriportConstantsService: AgriportConstantsService) {
  }

  public createUniformFieldset(formData: IPpPlanningWizardDetailsFormData): ApDynformsConfigFieldset[] {
    const uniformFieldSets = new Array<ApDynformsConfigFieldset>();
    uniformFieldSets.Add(new ApDynformsConfigFieldset({
      legend: 'Global__Agronomy',
      key: 'Agronomy',
      config: [
        new ApDynformsConfigNumerictextbox({
          key: nameOf<IPpPlanningWizardDetailsFormData>('ECStage'),
          label: 'Global__ECStage',
          decimals: 0,
          format: 'n0',
          min: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MIN'),
          max: +this.agriportConstantsService.GetConstant('GS_GLOBAL_MAX'),
          validators: [
            new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
          ]
        }),
        new ApDynformsConfigPlaceholder()
      ]
    }));

    // Add water fieldset only in case of worktype spraying
    // Otherwise it makes no sense to make inputs there
    if (formData.WorkType === WorkTypes.Spraying) {
      uniformFieldSets.Add(new ApDynformsConfigFieldset({
        legend: 'Global__Water',
        key: 'Global__Water',
        config: [
          new ApDynformsConfigNumerictextbox({
            key: nameOf<IPpPlanningWizardDetailsFormData>('WaterAvg'),
            label: `${this.translationService.translate('Global__Avg_Water')} [${this.translationService.translate('Unit_l_per_ha')}]`,
            min: 0,
            max: 500,
            decimals: 0,
            format: 'n0',
            infoText: 'Info_Uniform_PP',
            validators: [
              new ApDynformsValidator({validator: Validators.required, errorKey: 'Settings__Msg_Vali_Value_Required'})
            ]
          }),
          new ApDynformsConfigPlaceholder()
        ]
      }));
    }
    return uniformFieldSets;
  }
}
